import React from 'react';
import { ProductMasterDataContext, ProductMasterDataContextProps } from '../context/ProductMasterDataContext';
import { ProductMasterData } from '../types/product_master_data/productMasterData';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const productMasterDataState = {
  items: new Map<string, ProductMasterData>(),
  loading: false,
};

export const productMasterDataSlice = createSlice({
  name: 'productMasterData',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      productMasterDataState.items = new Map();
      productMasterDataState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<ProductMasterData[]>) => {
      productMasterDataState.items = new Map();
      action.payload.forEach(p => productMasterDataState.items.set(p.id, new ProductMasterData(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<ProductMasterData[]>) => {
      action.payload.forEach(p => productMasterDataState.items.set(p.id, new ProductMasterData(p)));
      productMasterDataState.items = new Map(productMasterDataState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<ProductMasterData[]>) => {
      action.payload.forEach(p => productMasterDataState.items.delete(p.id));
      productMasterDataState.items = new Map(productMasterDataState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      productMasterDataState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface ProductMasterDataProviderProps {
  children: React.ReactNode;
}

export default function ProductMasterDataProvider({ children }: ProductMasterDataProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.productMasterData.key);

  const pmdContext: ProductMasterDataContextProps = {
    productMasterData: productMasterDataState.items,
    productMasterDataLoading: productMasterDataState.loading,
    setProductMasterData: (pmd: Map<string, ProductMasterData>) => {
      dispatch(productMasterDataSlice.actions.set([...pmd.values()]));
    },
  };

  return <ProductMasterDataContext.Provider value={pmdContext}>{children}</ProductMasterDataContext.Provider>;
}
